angular.module('app').directive('searchFields', function() {
    return {
        'restrict': 'A',
        'require': 'ngModel',
        'scope': {
            'ctrl': '=searchCtrl',
            'fields': '=searchFields',
            'order': '@searchDefaultOrder'
        },
        'link': function(scope, elem, attr, ctrl) {
            scope.fields.forEach(function(name) {
                scope.ctrl.searchFields.push(name);
            });

            if(scope.order) {
                scope.ctrl.query.order = scope.order
            }

            ctrl.$viewChangeListeners.push(function() {
                scope.ctrl.query.page = 1;
                scope.ctrl.load();
            });
        }

    };
});
